import React from 'react';
import type { Message } from '../../services/chat.service';
import styles from './chat.module.css';

interface ChatMessageProps {
  message: Message;
  isLoading?: boolean;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message, isLoading }) => {
  const formatTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleTimeString('it-IT', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className={`${styles.message} ${styles[message.role]}`}>
      <div className={styles.messageContent}>
        <p>{message.content}</p>
        {isLoading && <div className={styles.loadingDots} />}
      </div>
      <span className={styles.timestamp}>{formatTime(message.timestamp)}</span>
    </div>
  );
};
